export default {
  ROOT: '/',
  LOGIN: '/login',
  DASHBOARD: '/dashboard',
  REPORT: '/report',
  ANALYZE: '/analyze',
  PROFILES_TEMPERATURE: '/profiles/temperature',
  PROFILES_SCHEDULE: '/profiles/schedule',
  ROOMS: '/rooms',
  TENANTS: '/tenants'
};
